export const IMAGE_AVAILABILITY_REASON = {
  NEVER_CAPTURED: "NEVER_CAPTURED",
  STILL_PROCESSING: "STILL_PROCESSING",
  DELETED: "DELETED",
  CAPTURE_FAILED: "CAPTURE_FAILED",
  SKIPPED_BY_DESIGN: "SKIPPED_BY_DESIGN",
};

export const IMAGE_AVAILABILITY_MESSAGE = {
  NEVER_CAPTURED: "No baseline has been captured for this test case yet.",
  STILL_PROCESSING: "This test run is still in progress — the screenshot hasn't been captured yet.",
  DELETED: "This screenshot was captured but has since been deleted (storage cleanup).",
  CAPTURE_FAILED: "The screenshot capture failed during this test run.",
  SKIPPED_BY_DESIGN: "Screenshot capture was skipped for this step by test suite configuration.",
};
